import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData } from './comonsearch';
import * as dataAccess from 'app/utils/ajax';

// GET /api/v1/admin/banner/analytics (Quick task 260921-lke, BL-05).
// Query params only — bannerId, page, limit, sortBy, sortOrder, startDate,
// endDate. No mall or tier param is ever built here (D-04/D-05); fetchData
// (comonsearch.js) already strips undefined/null/'' values before building
// the query string.
export const getBannerAnalytics = async (params) => {
  const baseUrl = `${API_CONSTANTS.BANNER}/analytics`;
  return await fetchData(baseUrl, params);
};

// Same route with download=true — the backend returns { jobId } instead of
// a page of rows.
export const downloadBannerAnalytics = async (params) => {
  const baseUrl = `${API_CONSTANTS.BANNER}/analytics`;
  return await fetchData(baseUrl, { ...params, download: true });
};

// export-status route is scoped under the banner segment (Banner_Management,
// D-02) — never the shared /admin/export/status (Analytics_and_Reporting),
// which would log out an admin who only holds Banner_Management. Mirrors
// getBillExportStatus in app/api/bill.js.
export const getBannerExportStatus = async (jobId) => {
  return await dataAccess.get(`${API_CONSTANTS.BANNER}/export-status/${jobId}`);
};
